export default () => ({
	form: document.getElementById('create-customer-form'),
	first_name: '',
	first_name_error: false,
	last_name: '',
	last_name_error: false,
	email: '',
	email_erorr: false,
	email_invalid: false,
	password: document.getElementById('RegisterForm-password'),
	password_error: false,
	confirm_password: document.getElementById('RegisterForm-confirm-password'),
	confirm_error: false,
	confirm_invalid: false,
	password_strength_error: false,
	password_strength_state: 0,
	strength_active: false,
	marketing_active: false,

	get strengthColor() {
		const bg_variable = '--strength-bg-color:';
		const width_bg = '--strength-width:';
		let bg_color = '';
		let width = '';

		if (this.password_strength_state === 0) {
			bg_color = '#fff';
			width = '0';
		}
		if (this.password_strength_state === 1) {
			bg_color = '#ffafae';
			width = '25%';
		}
		if (this.password_strength_state === 2) {
			bg_color = '#ffd6b3';
			width = '50%';
		}
		if (this.password_strength_state === 3) {
			bg_color = '#c5eeac';
			width = '75%';
		}
		if (this.password_strength_state === 4) {
			bg_color = '#81b562';
			width = '100%';
		}

		return `${bg_variable} ${bg_color}; ${width_bg} ${width};`;
	},

	checkValidity() {
		const regex =
			/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

		if (this.first_name === '') {
			this.first_name_error = true;
		} else {
			this.first_name_error = false;
		}

		if (this.last_name === '') {
			this.last_name_error = true;
		} else {
			this.last_name_error = false;
		}
		if (this.email === '') {
			this.email_erorr = true;
		} else {
			this.email_erorr = false;
		}
		if (this.email !== '' && !this.email.match(regex)) {
			this.email_invalid = true;
		} else {
			this.email_invalid = false;
		}

		if (this.password.value === '' || this.password.value.length <= 6) {
			this.password_error = true;
			this.password_strength_error = true;
		} else {
			this.password_error = false;
			this.password_strength_error = false;
		}

		if (this.confirm_password.value === '') {
			this.confirm_error = true;
		} else {
			this.confirm_error = false;
		}

		if (this.confirm_password.value !== '' && this.password.value !== this.confirm_password.value) {
			this.confirm_invalid = true;
		} else {
			this.confirm_invalid = false;
		}

		setTimeout(() => {
			const error_fields = [...this.form.querySelectorAll('.customer-register__input.error')];
			if (error_fields.length > 0) {
				error_fields[0].focus();
			}
		}, 50);
	},

	checkStrength() {
		if (this.password.value === '') {
			this.password_strength_state = 0;
		}
		if (this.password.value.match(/([0-9])/)) {
			this.password_strength_state = 1;
		}
		if (
			this.password.value.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) &&
			this.password.value.length > 5
		) {
			this.password_strength_state = 2;
		}
		if (this.password.value.match(/([!,%,&,@,#,$,^,*,?,_,~])/) && this.password.value.length > 6) {
			this.password_strength_state = 3;
			this.password_strength_error = false;
		}
		if (
			this.password.value.match(/([0-9])/) &&
			this.password.value.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) &&
			this.password.value.match(/([!,%,&,@,#,$,^,*,?,_,~])/) &&
			this.password.value.length >= 9
		) {
			this.password_strength_state = 4;
			this.password_strength_error = false;
		}

		if (this.password.value.length > 6) {
			this.password_strength_error = false;
		}

		if (this.password.value !== '') {
			this.strength_active = true;
		} else {
			this.strength_active = false;
		}
	},

	submit() {
		this.checkValidity();
		if (
			!this.first_name_error &&
			!this.last_name_error &&
			!this.email_erorr &&
			!this.email_invalid &&
			!this.password_error &&
			!this.confirm_error &&
			!this.confirm_invalid &&
			!this.password_strength_error
		) {
			this.form.submit();
		}
	},

	enableMarketing() {
		const checkbox = document.getElementById('customer-register-marketing');
		this.marketing_active = !this.marketing_active;
		if (this.marketing_active) {
			checkbox.checked = true;
		} else {
			checkbox.checked = false;
		}
	},
});
